import React, { useState } from 'react'
import { Loader } from 'lucide-react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import skinsApi from '../services/skinsApi'
import { closePreparedPaymentWindow, prepareExternalPaymentWindow } from '../utils/openExternalPaymentLink'

/**
 * SkinsPayment
 * Пополнение баланса скинами Steam через внешний сервис
 */
const SkinsPayment = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isProcessing, setIsProcessing] = useState(false)

  const handleSkinsPayment = async () => {
    if (isProcessing) return

    const paymentWindow = prepareExternalPaymentWindow()

    setIsProcessing(true)

    try {
      const { link } = await skinsApi.createSkinsPaymentLink()

      skinsApi.openSkinsPayment(link, () => {
        toast.success(t('payment.sbp.paymentNotification'), {
          duration: 4000,
          icon: '💳'
        })

        setTimeout(() => {
          navigate('/')
        }, 1500)
      }, paymentWindow)
    } catch (error) {
      closePreparedPaymentWindow(paymentWindow)
      console.error('❌ Ошибка создания платежа скинами:', error)

      if (error.message === 'BACKEND_ERROR') {
        toast.error(t('payment.sbp.errorBackend'))
      } else {
        toast.error(t('payment.createError'))
      }
    } finally {
      setIsProcessing(false)
    }
  }

  return (
    <div className="max-w-md mx-auto">
      <button
        onClick={handleSkinsPayment}
        disabled={isProcessing}
        className={`w-full py-4 rounded-lg font-bold text-lg transition-all ${
          !isProcessing
            ? 'bg-gradient-to-r from-accent-primary to-accent-secondary text-dark-primary hover:opacity-90'
            : 'bg-gray-600 text-gray-400 cursor-not-allowed'
        }`}
      >
        {isProcessing ? (
          <span className="flex items-center justify-center gap-2">
            <Loader size={20} className="animate-spin" />
            {t('payment.skins.creating')}
          </span>
        ) : (
          t('payment.skins.topUpButton')
        )}
      </button>
    </div>
  )
}

export default SkinsPayment
